<template>
  <v-container
    color="#1A1A1A"
    height="76px"
    class="pl-7 pt-6 pb-5 pr-6 ma-0"
    :style="borderBottom && 'border-bottom: 1px solid #4c4c4c !important'"
  >
    <v-row>
      <v-btn
        absolute
        class="pt-1 pl-1"
        icon
        @click="$emit('onBackButtonClick')"
      >
        <v-icon>$iconBack</v-icon>
      </v-btn>

      <v-col cols="12" class="pa-0" align="center">
        <v-toolbar-title>{{ title }}</v-toolbar-title>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "sidebar-toolbar",
  props: {
    title: {
      type: String,
      default: "Rooms",
    },
    borderBottom: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
